import { Controller } from "@hotwired/stimulus"
import Glide from '@glidejs/glide'

export default class extends Controller {
    static targets = ['slideCount'];

    connect() {
        new Glide('.glide', {
            type: 'carousel',
            gap: 40,
            perView: 3,
            rewind: false,
            breakpoints: {
                // Settings for under 768px
                768: {
                    perView: 1.5,
                    gap: 16,
                },
                // Settings for under 1024px
                1280: {
                    perView: 2,
                    gap: 16,
                },
            }
        }).mount();
    }
}
